import { KText } from '@/ui-library/components';
import {
  Box,
  Flex,
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger as ChakraPopoverTrigger,
  Portal,
  useDisclosure,
  Button,
} from '@chakra-ui/react';
import { PiSmileySadDuotone } from 'react-icons/pi';
import { Globe05 } from '@kula-ai/icons/dual-tone/Globe05';

// Type fix for PopoverTrigger
const PopoverTrigger: React.FC<{ children: React.ReactNode }> =
  ChakraPopoverTrigger;

interface SchInterviewerTimezoneNotSetProps {
  onSetTimezone?: () => void;
}

export const SchInterviewerTimezoneNotSet = ({
  onSetTimezone,
}: SchInterviewerTimezoneNotSetProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover
      isOpen={isOpen}
      onClose={onClose}
      placement="left"
      trigger="hover"
      isLazy
    >
      <PopoverTrigger>
        <Box
          as="span"
          display="inline-flex"
          onMouseEnter={onOpen}
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <Icon
            as={Globe05}
            w="16px"
            h="16px"
            color="secondary-700"
            flexShrink={0}
            cursor="pointer"
            _hover={{ color: 'secondary-900' }}
          />
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          bg="base-white"
          borderRadius="8px"
          border="none"
          p="0"
          w="380px"
          zIndex="popover"
          boxShadow="0px 71px 29px rgba(215, 218, 235, 0.01), 0px 40px 24px rgba(215, 218, 235, 0.05), 0px 18px 18px rgba(215, 218, 235, 0.09), 0px 4px 10px rgba(215, 218, 235, 0.1)"
          onMouseEnter={onOpen}
          onMouseLeave={onClose}
          onClick={(e) => e.stopPropagation()}
        >
          <Flex flexDir="column" p="12px" gap="8px">
            <Flex
              justifyContent="space-between"
              alignItems="flex-start"
              gap="8px"
            >
              <Flex gap="6px" alignItems="center" flex="1">
                <Icon
                  w="20px"
                  h="20px"
                  // @ts-expect-error -- pre-existing type debt (extraction move)
                  as={PiSmileySadDuotone}
                  color="secondary-700"
                  flexShrink={0}
                />
                <KText size="sm-medium" color="secondary-900">
                  Interviewer&apos;s timezone not available
                </KText>
              </Flex>
            </Flex>
            <KText size="sm" color="secondary-700">
              This interviewer hasn&apos;t set their timezone. <br /> Candidates
              can&apos;t see their availability without it.
            </KText>
            <Button
              width="fit-content"
              variant="tertiary"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onSetTimezone?.();
                onClose();
              }}
            >
              Set timezone
            </Button>
          </Flex>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
